<p-dialog [(visible)]="showSuspendEmployee" [closeOnEscape]="false" [showHeader]="false" [modal]="true" [draggable]="false" [style]="{width: '600px'}">
    <div *ngIf="!employeeIsSuspended">
        <div class="partner-employees-dialog-header">Suspend this employee</div>
        <div class="partner-employees-dialog-description" *ngIf="merchantUser.IsSuspended">Employee suspended until {{merchantUser.SuspendedUntil}}</div>
        <div class="partner-employees-dialog-description">Suspending an employee will automatically log them out and they will not be able to login until the period lapses</div>

        <div class="flex flex-row">
            <div style="margin-left: auto;">
                <div class="flex align-items-center partner-employees-remove-dialog-rbutton">
                    <p-radioButton name="pizza" [value]="suspendType.For1Day" [(ngModel)]="selectedSuspendType" inputId="1day"></p-radioButton>
                    <label for="1day" class="ml-2">24 hours</label>
                </div>

                <div class="flex align-items-center partner-employees-remove-dialog-rbutton">
                    <p-radioButton name="pizza" [value]="suspendType.For7Days" [(ngModel)]="selectedSuspendType" inputId="7days"></p-radioButton>
                    <label for="7days" class="ml-2">7 days</label>
                </div>
            </div>
            <div style="margin-right: auto; margin-left: 130px;">
                <div class="flex align-items-center partner-employees-remove-dialog-rbutton">
                    <p-radioButton name="pizza" [value]="suspendType.For3Days" [(ngModel)]="selectedSuspendType" inputId="3days"></p-radioButton>
                    <label for="3days" class="ml-2">3 days</label>
                </div>

                <div class="flex align-items-center partner-employees-remove-dialog-rbutton">
                    <p-radioButton name="pizza" [value]="suspendType.For30Days" [(ngModel)]="selectedSuspendType" inputId="30days"></p-radioButton>
                    <label for="30days" class="ml-2">30 days</label>
                </div>
            </div>
        </div>

        <div class="partner-employees-remove-dialog-input-label">Reason</div>

        <textarea [(ngModel)]="suspendReason" placeholder="Reason why you will suspend this employee…" rows="4" cols="30" pInputTextarea></textarea>

        <div class="flex flex-row" style="margin-top: 30px">
            <button [disabled]="loading" (click)="handleHideSuspendUserDialog()" pButton type="button" class="p-button-text" label="Cancel" style="width: 137px; height: 45px; margin-right: 13px; margin-left: auto"></button>
            <button [disabled]="loading || !selectedSuspendType" (click)="suspendMerchantUser()" class="red-btn" pButton label="Suspend" style="width: 137px; height: 45px;"></button>
        </div>
    </div>
    <div *ngIf="employeeIsSuspended">
        <div style="margin-top: 50px;" class="partner-employees-dialog-header">Employee suspended successfully</div>
        <div style="text-align:center">
            <button style="margin: 25px auto; width: 273px; height: 45px;" class="bluedark-btn" pButton label="Ok" (click)="handleHideSuspendUserDialog()"></button>
        </div>
    </div>
</p-dialog>